/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { showFormatedDate  } from '../actions/utilAction'
import PaginatorCustom from '../components/paginationCustom';
import { renderDateField } from '../components/reduxFields';
import { Field, reduxForm } from 'redux-form';
import { RaisedButton } from 'material-ui';
import { getOrganizationPayerResponses } from '../modules/Dashboards/actions/StaffDashboardActions';
import moment from 'moment';
import history from '../history';
import SortingCustom from '../components/SortingCustom';
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class PayerResponses extends Component {

  constructor(props) {
    super(props);
    this.filter = {
      sort_Column: '',
      sort_order: '', 
    };
    this.setSortColumn = this.setSortColumn.bind(this);
  }

  loadOrganizationPayerResponses(page_number) {
    let searchObj = {    
      pageNumber: page_number ? page_number : 1,
      pageSize: 10, 
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: {
        fromDate: this.props.FromPayerResponsesDate ? moment(this.props.FromPayerResponsesDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.props.ToPayerResponsesDate ? moment(this.props.ToPayerResponsesDate).format('YYYY-MM-DD') : new Date(),      
      }, 
    };
    this.props.getOrganizationPayerResponses(searchObj);
  }

  handleViewClaimClick = (event, obj) => {
    let claimId ='CL' + obj.claimId;
    history.push(`/claims/3/${claimId}`);    
  };


  handleReset = () => {   
    this.props.handleResetPayerResponse();
  };

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadOrganizationPayerResponses();
    }
  }

  showTableData() {
    return this.props.OrganizationPayerResponses.data.map((data) => {
      return (
        <TableRow key={data.id}>       
          <TableRowColumn width="20%">{data.patientName}</TableRowColumn>
          <TableRowColumn width="15%">{showFormatedDate(data.dos)}</TableRowColumn>
          <TableRowColumn width="15%">{'CL' + data.claimId}</TableRowColumn>
          <TableRowColumn width="20%">{data.payerName}</TableRowColumn>    
          {/* <TableRowColumn width="10%">{data.claimStatus}</TableRowColumn>     */}
          <TableRowColumn width="15%">{data.submittedAs}</TableRowColumn>                 
          {/* <TableRowColumn width="10%">
            {data.errorReasonDescription !== '' ?
              <Tooltip Description={data.errorReasonDescription} />
              : null} 
          </TableRowColumn>*/}
          <TableRowColumn width="10%">{data.errorReasonDescription !== '' ? data.errorReasonDescription : null}</TableRowColumn>
          <TableRowColumn width="5%"><button onClick={(e) => this.handleViewClaimClick(e, data)} type="button" title="View Claim" className="tbactionbtn blackfont"><i className="fa fa-eye" aria-hidden="true"></i></button></TableRowColumn>          
        </TableRow>
      );
    });
  }

  render() {
    return (
      <div>
         <div className="row">
          <div className="col-sm-12">
                <form className="readmin-form custom_form" >                
                  <div className="row end-flex">         
                    <div className="col-sm-4 ml-10">
                      <Field name="FromPayerResponsesDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.props.FromPayerResponsesDate}
                        onDateChange={this.props.onPayerResponseDateChange}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-4 ml-10">
                      <Field name="ToPayerResponsesDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate = {this.props.FromPayerResponsesDate}
                        selected={this.props.ToPayerResponsesDate}
                        openToYearSelection={true}
                        onDateChange={this.props.onPayerResponseDateChange}
                        component={renderDateField} />
                    </div>
                    
                    <div className="reset-btn col-sm-4 btn_rt">
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
              </form>    
          </div>
        </div>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>            
              <TableHeaderColumn width="20%">
                <SortingCustom noSort={this.props.OrganizationPayerResponses && this.props.OrganizationPayerResponses.data && !this.props.OrganizationPayerResponses.data.length} setSortColumn={this.setSortColumn} columnName='clientName' displayName='Client Name' />
              </TableHeaderColumn>
              <TableHeaderColumn width="15%">
                <SortingCustom noSort={this.props.OrganizationPayerResponses && this.props.OrganizationPayerResponses.data && !this.props.OrganizationPayerResponses.data.length} setSortColumn={this.setSortColumn} columnName='dos' displayName='DOS' />
              </TableHeaderColumn>
              <TableHeaderColumn width="15%">
                <SortingCustom noSort={this.props.OrganizationPayerResponses && this.props.OrganizationPayerResponses.data && !this.props.OrganizationPayerResponses.data.length} setSortColumn={this.setSortColumn} columnName='claimid' displayName='Claim Id' />
              </TableHeaderColumn>      
              <TableHeaderColumn width="20%">
                <SortingCustom noSort={this.props.OrganizationPayerResponses && this.props.OrganizationPayerResponses.data && !this.props.OrganizationPayerResponses.data.length} setSortColumn={this.setSortColumn} columnName='payername' displayName='Payer Name' />
              </TableHeaderColumn>              
              {/* <TableHeaderColumn width="10%">Status</TableHeaderColumn>      */}
              <TableHeaderColumn width="15%">Submitted As</TableHeaderColumn>                   
              <TableHeaderColumn width="10%">Denial Reason</TableHeaderColumn>                      
              <TableHeaderColumn width="5%">View</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.OrganizationPayerResponses && this.props.OrganizationPayerResponses.data && this.props.OrganizationPayerResponses.data.length > 0 ?
              this.showTableData()              
              : 
              <TableRow>
                <TableRowColumn colSpan="6">No Record Found</TableRowColumn>
              </TableRow>
              }
          </TableBody>
        </Table>
        {this.props.OrganizationPayerResponses && this.props.OrganizationPayerResponses.data && this.props.OrganizationPayerResponses.data.length ?
          <PaginatorCustom data={this.props.OrganizationPayerResponses.meta}  handlePageChange={(page_number) => this.loadOrganizationPayerResponses(page_number)} />
          : null}
      </div>
    );
  }
}
PayerResponses = reduxForm({
  form: 'PayerResponsesForm',
})(PayerResponses);

function mapStateToProps(state) {

  // console.log('state........',state)
  return {
    OrganizationPayerResponses: state.staff_dashboard ? state.staff_dashboard.OrganizationPayerResponses : {},
    //BottonPanel_loading: state.staff_dashboard.BottonPanel_loading,    
  }
}

export default connect(mapStateToProps, { getOrganizationPayerResponses })(PayerResponses);





// WEBPACK FOOTER //
// ./src/adminCharts/PayerResponses.js